<script>
  import contentMap from '../../utils/ContentMapLayout';
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';
  
  let {
    columnOneContent,
    columnTwoContent,
    translateUp = false,
    headingClasses = $bindable(),
    headingLevel = 'h2',
    headingText,
    dataTestId = 'layout-two-column',
  } = $props();

  let translateUpClasses = $state('');

  if (translateUp) {
    translateUpClasses = 'lg:-mt-25 xl:-mt-28 lg:relative lg:z-10';
  }

  if (headingText) {
    headingClasses = headingClasses
      ? headingClasses
      : 'font-semibold text-blue-dark-navy mx-4 mt-6 lg:mt-10 lg:mb-2 sm:text-center text-xl sm:text-1.5xl md:text-2xl lg:text-3xl';
  }
</script>

<div class="mx-auto md:my-7 lg:my-10 max-w-6xl {translateUpClasses}" data-testid={dataTestId}>
  {#if headingText}
    <BaseHeading className={headingClasses} {headingLevel}>
      {headingText}
    </BaseHeading>
  {/if}
  <div class="flex flex-col lg:flex-row lg:justify-around">
    <div class="px-4 lg:px-0 flex-1 lg:mx-4">
      {#each columnOneContent.imports as content (content.id)}
        {@const SvelteComponent = contentMap[content.__typename]}
        <SvelteComponent {...content} />
      {/each}
    </div>
    <div class="px-4 lg:px-0 flex-1 lg:mx-4">
      {#each columnTwoContent.imports as content (content.id)}
        {@const SvelteComponent_1 = contentMap[content.__typename]}
        <SvelteComponent_1 {...content} />
      {/each}
    </div>
  </div>
</div>
